<template>
    <section class="operate-wrap pt-6 pl-6 pr-8">
        <div class="business-flow tender-wrap rounded-md relative">
            <timer></timer>
            <el-tabs v-model="activeName">
                <el-tab-pane label="物流选择" name="first">
                    <section class="px-10 py-6">
                        <div v-if="dataTable.length !== 0">
                            <el-button
                                type="primary"
                                class="px-6 btn-blue"
                                @click="arrangeLogistics"
                                :disabled="disableSign"
                            >
                                安排物流</el-button
                            >
                        </div>
                        <div class="pt-5">
                            <div class="py-3 sem-no-data text-center" v-if="dataTable.length === 0">
                                <el-empty
                                    description="暂无内容"
                                    :image="imgUrl"
                                    class="pb-6"
                                ></el-empty>
                            </div>

                            <el-table
                                border
                                v-if="dataTable.length !== 0"
                                :data="dataTable"
                                style="width: 100%"
                                class="data-table small data-transparent"
                                show-summary
                                :summary-method="getSummaries"
                                @selection-change="handleSelectionChange"
                            >
                                <el-table-column type="selection" width="55" align="center">
                                </el-table-column>
                                <el-table-column
                                    label="订单信息"
                                    class-name="tender-info"
                                    width="360"
                                >
                                    <template slot-scope="scope">
                                        <div class="flex items-center pl-2">
                                            <div class="ava">
                                                <i class="iconfont iconorder-form"></i>
                                            </div>
                                            <div class="flex-1 ml-2">
                                                <span>{{ scope.row.no }}</span>
                                                <p class="text-xs text-gray-400 pt-1">
                                                    客户名：{{ scope.row.customerName }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="productName"
                                    label="商品名称"
                                ></el-table-column>
                                <el-table-column prop="deliveryCityName" label="出库城市">
                                </el-table-column>
                                <el-table-column
                                    prop="deliveryCityName"
                                    :formatter="formatDeliveryCityName"
                                    label="出库配送中心"
                                >
                                </el-table-column>
                                <el-table-column prop="cityName" label="达到城市">
                                </el-table-column>
                                <el-table-column prop="buyNum" label="购买数量"> </el-table-column>
                                <el-table-column prop="sales" label="销售额"> </el-table-column>
                                <el-table-column prop="expressPrice" label="运费">
                                </el-table-column>
                                <el-table-column prop="subscribeTime" label="受订时间">
                                </el-table-column>
                            </el-table>
                            <div
                                v-if="dataTable.length > 0"
                                class="page-pagination pt-4 flex justify-between items-center"
                            >
                                <div class="c-title">
                                    共{{ pageTotal }}条，已选择
                                    <span class="orange font-bold">{{
                                        multipleSelection.length
                                    }}</span>
                                    条
                                </div>
                                <el-pagination
                                    layout="prev, pager, next"
                                    :page-size="queryParams.pageSize"
                                    :current-page="queryParams.pageIndex"
                                    @current-change="handleCurrentChange"
                                    :total="pageTotal"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </section>
                </el-tab-pane>
                <el-tab-pane label="规则说明" name="second">
                    <ruleDescription></ruleDescription>
                </el-tab-pane>
                <el-tab-pane label="经营状态" name="third">
                    <empiricalState v-if="activeName == 'third'"></empiricalState>
                </el-tab-pane>
            </el-tabs>
        </div>
    </section>
</template>

<script>
import timer from '../components/timer';
import ruleDescription from '../components/ruleDescription';
import empiricalState from '../components/empiricalState';
import { getOrderExpress, orderExpress, isEndSign } from '@/api/operate.js';
export default {
    name: 'ECOHigherWebExpress',
    components: { timer, ruleDescription, empiricalState },
    data() {
        return {
            activeName: 'first',
            dataTable: [],

            imgUrl: require('@/assets/images/student/sem-empty.png'),

            multipleSelection: [],
            queryParams: {
                pageIndex: 1,
                pageSize: 10
            },
            pageTotal: 0,
            money: 0.0,
            disableSign: false
        };
    },

    mounted() {
        this.initData();
    },

    methods: {
        formatDeliveryCityName(row) {
            return row.deliveryCityName + '配送中心';
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //初始化数据
        initData() {
            let _this = this;
            getOrderExpress(_this.queryParams.pageIndex, _this.queryParams.pageSize).then(res => {
                if (res) {
                    _this.dataTable = res.data;
                    _this.pageTotal = res.pageRecord;
                }
            });
            isEndSign().then(res => {
                _this.disableSign = res;
            });
        },
        //当前页数发生改变事件
        handleCurrentChange(val) {
            this.queryParams.pageIndex = val;
            this.initData();
        },

        //安排物流
        arrangeLogistics() {
            let _this = this;
            if (_this.multipleSelection.length == 0) {
                _this.$message({
                    message: '请选择订单',
                    type: 'info'
                });
                return;
            } else {
                _this.money = _this.multipleSelection.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.expressPrice;
                }, 0);
            }
            const h = this.$createElement;
            _this
                .$msgbox({
                    title: '物流提示',
                    message: h('p', null, [
                        h('span', null, '需要支付运费 '),
                        h('span', _this.money + ' 元'),
                        h('span', null, '，确定安排这  '),
                        h(
                            'span',
                            { style: 'font-weight: bold;color: #172d4f' },
                            _this.multipleSelection.length
                        ),
                        h('span', null, ' 个订单的物流？ ')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'confirm-warning'
                })
                .then(() => {
                    let ids = _this.multipleSelection.map(item => {
                        return item.id;
                    });
                    orderExpress(ids).then(res => {
                        if (res.success === true) {
                            _this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            _this.queryParams.pageIndex = 1;
                            _this.initData();
                        } else {
                            _this.$message({
                                message: res.message ? res.message : '操作失败',
                                type: 'error'
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        arrangeLogisticss() {
            let _this = this;
            _this
                .$confirm('余额不够支付运费，请重新操作。', '物流提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'confirm-warning'
                })
                .then(() => {
                    _this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                })
                .catch(() => {});
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            const emptyStatus = [2, 3, 4, 5, 6, 9];
            columns.forEach((column, index) => {
                if (index === 1) {
                    sums[index] = '合计';
                    return;
                }
                if (emptyStatus.includes(index)) {
                    sums[index] = '/';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values
                        .reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0)
                        .toFixed(2);
                }
            });

            return sums;
        }
    }
};
</script>
<style scoped>
@tailwind components;

@layer components {
    .ava {
        @apply w-8 h-8 rounded-full flex justify-center items-center;
        background: rgba(37, 193, 73, 0.14);
    }
    .ava .iconfont {
        color: #25c149;
    }

    .orange {
        color: #fe995b;
    }
    .el-table /deep/ .el-table__footer-wrapper tbody td:nth-child(8),
    .el-table /deep/ .el-table__footer-wrapper tbody td:nth-child(9) {
        color: #fe995b;
        font-weight: bold;
    }
}
</style>
